/**
 * Labstep
 *
 * @module components/ResourceTemplate/Action/ShareLink
 * @desc Share a resourceTemplate with all users on the platform
 */

import { EntityActionShare } from 'labstep-web/components/Entity/Action/Share';
import type React from 'react';
import type { IResourceTemplateActionShareProps } from './types';

export const ResourceTemplateActionShare: React.FC<
  IResourceTemplateActionShareProps
> = ({ resourceTemplate }) => (
  <EntityActionShare entity={resourceTemplate} />
);
